module.exports = __webpack_public_path__ + "static/media/sad_man.15f56b52.jpg";